export default __webpack_public_path__ + "static/media/car-img.1d2da7c3.png";